<script setup lang="ts">
import {
  IconFacebook,
  IconLinkedin,
  IconTwitter,
  IconInstagram,
  IconTelegramPlane
} from "@iconify-prerendered/vue-fa-brands";
import { branding } from "@/config/branding";

type FooterSocialLink = {
  icon: any;
  url: string;
  title: string;
};
const links: FooterSocialLink[] = [
  {
    icon: IconFacebook,
    title: "Facebook",
    url: "#"
  },
  {
    icon: IconLinkedin,
    title: "LinkedIn",
    url: "#"
  },
  {
    icon: IconTwitter,
    title: "Twitter",
    url: "#"
  },
  {
    icon: IconInstagram,
    title: "Instagram",
    url: "#"
  },
  {
    icon: IconTelegramPlane,
    title: "Telegram",
    url: "#"
  }
];

type IBottomLink = {
  url: string;
  title: string;
};
const linksBottom: IBottomLink[] = [
  {
    url: "#",
    title: "footer.links.terms-conditions"
  },
  {
    url: "#",
    title: "footer.links.privacy-policy"
  },
  {
    url: "#",
    title: "footer.links.cookies-policy"
  }
];
</script>

<template>
  <footer class="min-h-[120px] w-screen mt-1 py-6 backdrop-blur-xl border-t bg-gray-900/40 border-gray-800/30 flex items-center">
    <div
      class="mx-6 xl:mx-auto w-screen xl:w-[1200px] h-full flex flex-col lg:flex-row lg:items-center gap-4"
    >
      <!-- Logo removed -->

      <!-- Центр: ссылки и социальные иконки -->
      <div class="flex flex-col lg:flex-row items-center justify-center gap-4 lg:gap-6">
        <div class="flex items-center gap-4">
          <RouterLink
            v-for="link of linksBottom"
            :to="link.url"
            class="text-sm whitespace-nowrap text-gray-300 hover:text-white transition-colors"
          >
            {{ $t(link.title) }}
          </RouterLink>
        </div>
        <div class="flex gap-2 items-center">
          <a
            :href="link.url"
            class="text-gray-400 hover:text-gray-300 transition-colors"
            v-for="link in links"
          >
            <span class="sr-only">{{ link.title }}</span>
            <component :is="link.icon" class="w-[24px]" />
          </a>
        </div>
      </div>

      <!-- Copyright справа -->
      <div class="flex items-center lg:flex-1 lg:justify-end">
        <span class="copyright">{{ branding.copyrightText }}</span>
      </div>
    </div>
  </footer>
</template>

<style scoped lang="scss">
.copyright {
  font-weight: 500;
  font-size: 14px;
  line-height: 38px;
  color: rgb(156, 163, 175); /* gray-400 */
}
</style>
